var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    class: _vm.$style.container
  }, [_c('div', {
    class: _vm.$style.header
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('screen-header', {
          attrs: {
            "title": _vm.$t('choose.card.for.payout'),
            "history-mode": false
          },
          on: {
            "navigate": _vm.handleNavigate
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('div', [_c('navigate-button', {
          directives: [{
            name: "absolute",
            rawName: "v-absolute"
          }, {
            name: "left",
            rawName: "v-left",
            value: -80,
            expression: "-80"
          }],
          on: {
            "navigate": _vm.handleNavigate
          }
        }), _c('screen-title', {
          attrs: {
            "title": _vm.$t('card.binding.title')
          }
        })], 1)];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_vm._l(_vm.sortedData, function (card, index) {
    return _c('selectable-card-panel', {
      directives: [{
        name: "m-b",
        rawName: "v-m-b",
        value: 20,
        expression: "20"
      }],
      key: index,
      attrs: {
        "card": card
      },
      on: {
        "click": function click($event) {
          return _vm.handleChangeCard(card);
        }
      },
      scopedSlots: _vm._u([_vm.getLimitByCard(card) ? {
        key: "additional",
        fn: function fn() {
          return [_c('payout-limits', {
            attrs: {
              "currency": _vm.getCurrency,
              "limits": _vm.getLimitByCard(card),
              "loading": _vm.loading
            }
          })];
        },
        proxy: true
      } : null], null, true)
    });
  }), _c('adding-new-panel', {
    attrs: {
      "message": _vm.$t('bind.new.card')
    },
    on: {
      "click": function click($event) {
        return _vm.$router.push({
          name: 'card.binding'
        });
      }
    }
  })], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }